import Aos from "aos";
import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import About from "./pages/About";
// import Location from "./pages/Location";
import Career from "./pages/Career";
import Franchise from "./pages/Franchise";
// import Catalogs from "./pages/Catalogs";
import "aos/dist/aos.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/fontawesome.min.css";
import "./assets/css/jquery.datetimepicker.min.css";
import "./assets/css/layerslider.min.css";
import "./assets/css/magnific-popup.min.css";
import "./assets/css/slick.min.css";
import "./assets/css/style.css";
import "./assets/css/color.css";
import "./assets/css/responsive.css";
import "./assets/css/style.css.map";
import "./App.css";
import EngagementCakeGallery from "./pages/EngagementCakeGallery";
import BarbieCakeGallery from "./pages/BarbieCakeGallery";
import MakeUpCakeGallery from "./pages/MakeUpCakeGallery";
import BabyShowerCakeGallery from "./pages/BabyShowerCakeGallery";
import CartoonCakeGallery from "./pages/CartoonCakeGallery";
import LettersCakeGallery from "./pages/LettersCakeGallery";
import DigitsCakeGallery from "./pages/DigitsCakeGallery";
import SportsCakeGallery from "./pages/SportsCakeGallery";
import PopularMenuItems from "./pages/PopularMenuItems";
import { Suspense } from "react";

// Lazy load the Catalogs component
const Catalogs = React.lazy(() => import("./pages/Catalogs"));
const Location = React.lazy(() => import("./pages/Location"));

function App() {
  setInterval(() => {
    Aos.init({
      duration: 1000,
    });
  }, 1000);

  return (
    <>
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/popularmenuitems" exact element={<PopularMenuItems />} />
        <Route path="/contact" exact element={<Contact />} />
        <Route path="/about" exact element={<About />} />
        <Route path="/gallery" exact element={<Gallery />} />

        <Route
          path="/catalogs"
          exact
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Catalogs />
            </Suspense>
          }
        />
        <Route
          path="/location"
          exact
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <Location />
            </Suspense>
          }
        />

        <Route
          path="/engagementcakegallery"
          exact
          element={<EngagementCakeGallery />}
        />
        <Route
          path="/barbiecakegallery"
          exact
          element={<BarbieCakeGallery />}
        />
        <Route
          path="/makeupcakegallery"
          exact
          element={<MakeUpCakeGallery />}
        />
        <Route
          path="/babyshowercakegallery"
          exact
          element={<BabyShowerCakeGallery />}
        />
        <Route
          path="/cartooncakegallery"
          exact
          element={<CartoonCakeGallery />}
        />
        <Route
          path="/letterscakegallery"
          exact
          element={<LettersCakeGallery />}
        />
        <Route
          path="/digitscakegallery"
          exact
          element={<DigitsCakeGallery />}
        />
        <Route
          path="/sportscakegallery"
          exact
          element={<SportsCakeGallery />}
        />
        <Route path="/career" exact element={<Career />} />
        <Route path="/franchise" exact element={<Franchise />} />
      </Routes>
    </>
  );
}

export default App;
